import styled from "@emotion/styled"
import { Attribute } from "api"
import { LocationContext } from "contexts/LocationProvider"
import Image from "next/image"
import { Dispatch, SetStateAction, useContext, } from "react"
import { trackMapServiceFilter } from "reusable/ChargeGTM"
import { trackStationsFilter } from "reusable/gtm"

export const StyledLegend = styled.legend`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  white-space: nowrap;
`
const StyledFiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 10px;
  row-gap: 20px;
`
const StyledImage = styled.div`
  position: relative;
  width: 13px;
  height: 13px;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 13px;
    height: 13px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    width: 20px;
    height: 20px;
  }
`
const StyledClickable = styled.button<{ $selected: boolean }>`
  display: flex;
  gap: 4px;
  align-items: center;
  border-radius: 20px;
  font-family: inherit;

  border: 1px solid #5c6474;
  background: ${(props) => (props.$selected ? " #5c6474" : "#FFF")};
  cursor: pointer;
  color: ${(props) => (props.$selected ? " #FFF" : "#5c6474")};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  padding: 6px 10px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 4px 5.33px 4px 6.67px;
    font-size: 12px;
    line-height: 18px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    font-size: 14px;
    line-height: 20px;
    padding: 6px 10px;
  }
  img {
    filter: ${(props) => (props.$selected ? "brightness(0) invert(1)" : "")};
  }
`

type FilterContainerProps = {
  filters: Attribute[],
  interimFilters: Attribute[], // (attributes: Attribute[]) => void"
  setInterimFilters: Dispatch<SetStateAction<Attribute[]>>
  isPazCharge: boolean
}
export const FilterContainer = ({ filters, interimFilters, setInterimFilters, isPazCharge }: FilterContainerProps) => {
  const { updateFilters, selectedLocation } = useContext(LocationContext)
  const handleSelectFilter = (isSelected: boolean, filt: Attribute) => {
    let updatedFilters
    if (isSelected) {
      updatedFilters = interimFilters.filter((el) => el.id !== filt.id)
    } else {
      updatedFilters = [...interimFilters, filt]
    }
    updateFilters([...updatedFilters])
    setInterimFilters(updatedFilters)
    if (isPazCharge) {
      trackMapServiceFilter(filt.name)
    } else {
      trackStationsFilter(updatedFilters)
    }
  }
  return (
    <StyledFiltersContainer>
      {filters.map((filt, index) => {
        const isSelected = interimFilters.some(
          (el) => el.id === filt.id,
        )
        return (
          <StyledClickable
            $selected={isSelected}
            onClick={() => handleSelectFilter(isSelected, filt)}
            key={index.toString()}
            tabIndex={selectedLocation ? -1 : 0}
            aria-checked={isSelected}
            role="checkbox"
          >
            {filt.image && (
              <StyledImage>
                <Image alt='' src={filt.image} fill />
              </StyledImage>
            )}
            {filt.name}
          </StyledClickable>
        )
      })}
    </StyledFiltersContainer>
  )
}
